
Checkout.Payment.CreditCard = function(checkout, payment) {
	var creditcard = this;

	this.label = 'Credit Card';
	this.noDisplayCombo = ['paypal']; // don't even display the add-multi option

	this.fieldToSelector = {
		'cardType': '.select-cardtype',
		'cardNum': '.js-bt-cc',
		'expDate': '.js-bt-exp',
		'cvc': '.js-bt-cvv',
		'storeOnAccountWrap' : '.credit-card-store-wrap',
		'storeOnAccount' : '.credit-card-store'
	};

	this.$addAnotherMenu = $('#payment-method-add-another');
	this.$addAnotherMenuSelect = this.$addAnotherMenu.children('select');
	this.$tpl = $('#payment-method-creditcard-tpl');
	this.$wrap = false;

    this.bt = false;
    this.btStyles = {
        'input' : {
            'font-size' : "14px",
            'font-family' : "Trebuchet MS, Roboto, Arial, sans-serif",
            'font-weight' : "normal",
        },
        ':focus' : {
            'color' : "#282828",
        },
        '.valid' : {
            'color' : "#093",
        },
    };
    this.btInputMap = {
        'number'         : "cardNum",
        'cvv'            : "cvc",
        'expirationDate' : "expDate",
    };
    this.data = {};

	this.init = function() {

		if (checkout.config.isEndeca) {
			this.$addAnotherMenu.show();
			this.$addAnotherMenuSelect.children('select option[value=paypal]').show();
		}

		if (creditcard.getContainer().children().length == 6) {
			creditcard.addError = 'Maximum of 6 Credit Cards Allowed';
			return;
		}

		creditcard.$wrap = creditcard.$tpl
			.clone(true)
			.removeAttr('id');

		$.each(creditcard.fieldToSelector, function(field, selector) {
			creditcard['$'+field] = creditcard.$wrap.find(selector);
		});

		var $cardHelpButtons = creditcard.$wrap.find('[rel=popover]');

		if (checkout.config.isEndeca) {
			/* Shows, places and adds content to credit card help popovers in conjunction with #payment-content-wrapper .popover commands in style-2016927.css and bootstrap in an unclear manner. */
			$cardHelpButtons.popover({
				'html': true,
				'trigger': 'manual',
				'placement': 'right',
				'content': function(){return '<img src="'+$(this).data('img') + '" />';}
			}).on('click', function(e) {
				e.stopPropagation();
				var left = $(this).position().left;
				var width = $(this).outerWidth();
				var popoverPosition = left + width + 15;
				$('.popover').css('display','none');
				$(this).siblings('.popover').css('position','absolute');
				$(this).popover('show');
			});

			$(document).on('click', function(e) {
				$('.popover').css('display','none');
			});
		} else {
			$cardHelpButtons
				.popover({
					'html': true,
					'trigger': 'click',
					'placement': 'right',
					'content': function(){return '<img src="'+$(this).data('img') + '" />';}
				});

			/*
			// this doesn't work with bootstrap 4 
			$cardHelpButtons.each(function(i, button) {
				$(button).data(checkout.config.bsPopoverData).tip()
					.find('.popover-title')
					.hide()
			});
			*/
		}

        checkout.payment.getBT( function() { creditcard.createHostedFields() } );

		creditcard.listen();
	};

	this.listen = function() {

		creditcard.$wrap.find('.select-cardtype').change(function() {
			creditcard.changeCardType($(this));
		});

	};

	this.getContainer = function() {
		if (!payment.creditCardWrap)
			payment.creditCardWrap = new Checkout.Payment.CreditCardWrap(checkout, payment);

		return payment.creditCardWrap.$container;
	};

	this.afterRemoved = function() {
		if (!creditcard.getContainer().children().length) {
			payment.creditCardWrap.remove();
			payment.creditCardWrap = false;
		}
	};

	this.clearInput = function() {
		creditcard.$wrap.find('input').val('');
	};

	this.changeCardType = function($select) {
		var $creditCard = $select.parents('.payment-method').first(),
			cardTypeVal = $select.val(),
			cardType = creditCardTypes[cardTypeVal];

		$creditCard.find('.credit-card')
			.attr(
				'class',
				'payment-method-wrap clearfix credit-card ' + (cardTypeVal || '') + ' gr-' + (cardTypeVal || 'mastercard')
			);

		$creditCard.find('.logo')
			.html(cardType.logo);

		$creditCard.find('.watermark')
			.html(cardType.watermark);

	};

    this.prepareData = function( callback ) {
        creditcard.hostedFieldsInterface.tokenize( function( err, payload ) {
            creditcard.data.cardNum = 1;
            creditcard.data.expDate = 1;
            creditcard.data.cvc = 1;

            if ( err ) {
                console.error( "Failed to tokenize", err );
                if ( err.details ) {
                    $.each( err.details.invalidFieldKeys, function( i, btFieldKey ) {
                        var fieldName = creditcard.btInputMap[ btFieldKey ];
                        if ( fieldName ) creditcard.data[ fieldName ] = 0;
                    } );
                }
                else if ( err.code == "HOSTED_FIELDS_FIELDS_EMPTY" ) {
                    creditcard.data.cardNum = 0;
                    creditcard.data.expDate = 0;
                    creditcard.data.cvc = 0;
                }
            }
            else {
                creditcard.data.nonce = payload.nonce;
            }

            callback();
        } );
    };

	this.getData = function() {
		creditcard.data.storeOnAccount =  creditcard.$storeOnAccount.prop('checked') ? 1 : 0;

		return creditcard.data;
	};

	this.validate = function() {
		return true;
	};

	this.fieldErrors = function(errors) {
		for (var field in errors)
			payment.fieldError(creditcard['$'+field], errors[field]);
	};

    this.createHostedFields = function() {
        creditcard.setHostedFieldIDs();

        if( ! window.braintree ) return console.error( "Missing BT interface" );
        window.braintree.hostedFields.create(
            {
                'client' : bt,
                'styles' : creditcard.btStyles,
                'fields' : {
                    'number' : {
                        'selector' : "#bt-cc-" + checkout.BTid,
                    },
                    'cvv' : {
                        'selector' : "#bt-cvv-" + checkout.BTid,
                    },
                    'expirationDate' : {
                        'selector' : "#bt-exp-" + checkout.BTid,
                        'placeholder' : 'MM/YY',
                    },
                },
            },
            function( err, hostedFieldsInterface ) {
                if( err ) return console.error( "Hosted fields failed", err );

                creditcard.hostedFieldsInterface = hostedFieldsInterface;
            }
        );
    };

    this.setHostedFieldIDs = function() {
        checkout.BTid ++;

        var fields = [ "cc", "exp", "cvv" ];
        $.each( fields, function( i, field ) {
            var $field = creditcard.$wrap.find( ".js-bt-" + field );
            $field.attr( "id", "bt-" + field + "-" + checkout.BTid );
        } );

        return;
    };

	this.init();
};

